import React from 'react'

import { LOCIZE_NAMESPACE } from 'main/common'
import { palette, Text } from 'main/ui'
import { formatCurrencyRange } from 'main/util/currency'
import { useTranslation } from 'react-i18next'
import { i18nKeyPrefix } from '../../i18n'

const PRE = `${i18nKeyPrefix}-CALLOUT-PRICING`

interface IProps {
  min: number
  max: number
  weeklyMin: number | null
  weeklyMax: number | null
  showWeeklyPricesOnly?: boolean
}

function formatPriceRange(min: number, max: number, period: string) {
  return `${formatCurrencyRange(min, max, { separator: '-' })}/${period}`
}

export default function Pricing(props: IProps) {
  const { min, max, weeklyMin, weeklyMax, showWeeklyPricesOnly = false } = props
  const hasWeeklyPrices = weeklyMin !== null && weeklyMax !== null
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  function formatPricing() {
    if (showWeeklyPricesOnly && hasWeeklyPrices) {
      return formatPriceRange(weeklyMin!, weeklyMax!, t(`${PRE}-WEEK`))
    }
    if (!showWeeklyPricesOnly && hasWeeklyPrices) {
      return `${formatPriceRange(min, max, t(`${PRE}-MONTH`))} • ${formatPriceRange(
        weeklyMin!,
        weeklyMax!,
        t(`${PRE}-WEEK`),
      )}`
    }
    return formatPriceRange(min, max, t(`${PRE}-MONTH`))
  }

  return <Text css={{ color: palette.mediumGray, fontSize: '14px' }}>{formatPricing()}</Text>
}
